/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecommendationsSortCriteria {
    getFixupPrototypeFunction() { return ResourceRecommendationsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecommendationsSortCriteria>): ResourceRecommendationsSortCriteria {
        let obj = Object.assign(new ResourceRecommendationsSortCriteria(), model);
        ResourceRecommendationsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecommendationsSortCriteria>): ResourceRecommendationsSortCriteria {
        if (!model) return null;
        return ResourceRecommendationsSortCriteria.newInstance(<ResourceRecommendationsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecommendationsSortCriteria) {
        if (!obj) return;

        models.ResourceRecommendationsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecommendationsSortCriteria): boolean {
        Object.setPrototypeOf(obj, ResourceRecommendationsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ResourceRecommendationsSortColumn;

    ascending: boolean;

}
